/**
 * Formata instante ISO (LocalDateTime do backend) para pt-BR.
 * @param {string|null|undefined} iso
 * @returns {string}
 */
export function formatDateTimeBR(iso) {
    if (iso == null || iso === '') {
        return '—';
    }
    const s = String(iso).trim();
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) {
        return s;
    }
    return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}
